import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";
const projectionConfig = { scale: 118, center: [12, 22] };

export function GlobalPresence({ content, mapRegions }) {
  const groupedRegions = mapRegions.reduce((groups, region, index) => {
    const groupName = region.group || "Other";
    if (!groups[groupName]) groups[groupName] = [];
    groups[groupName].push({ ...region, label: content.regions[index] || region.name || region.key });
    return groups;
  }, {});

  return (
    <section id="global" className="section global-presence-section" data-slide="07" data-testid="global-presence-section">
      <div className="section-heading">
        <p className="overline" data-testid="global-overline">{content.overline}</p>
        <h2 data-testid="global-title">{content.title}</h2>
      </div>

      <div className="global-map realistic" data-testid="global-map">
        <ComposableMap
          className="map-svg"
          projection="geoMercator"
          projectionConfig={projectionConfig}
          data-testid="world-map-svg"
          aria-label="Premium world map with Trinity active customer regions"
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography key={geo.rsmKey} geography={geo} className="map-country" tabIndex={-1} />
              ))
            }
          </Geographies>
          {mapRegions.map((region) => (
            <Marker key={region.key} coordinates={region.coordinates} data-testid={`map-marker-${region.key}`}>
              <g className="svg-map-marker" aria-label={`Project region: ${region.name}`}>
                <circle r="7" />
                <circle r="2.2" />
              </g>
            </Marker>
          ))}
        </ComposableMap>
      </div>

      <div className="global-region-groups" data-testid="global-region-groups">
        {Object.entries(groupedRegions).map(([groupName, regions]) => (
          <div className="global-region-group" key={groupName} data-testid={`global-region-group-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
            <strong data-testid={`global-region-group-title-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>{groupName}</strong>
            <div className="global-region-list" data-testid={`global-region-list-${groupName.toLowerCase().replaceAll(" ", "-").replaceAll("&", "and")}`}>
              {regions.map((region, index) => (
                <span key={region.key} data-testid={`global-region-chip-${groupName.toLowerCase().replaceAll(" ", "-")}-${index + 1}`}>{region.label}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="stat-grid" data-testid="global-stats">
        {content.stats.map((stat) => (
          <div className="stat-item" key={stat} data-testid={`global-stat-${stat.toLowerCase().replaceAll(" ", "-").replaceAll("+", "plus")}`}>
            {stat}
          </div>
        ))}
      </div>
    </section>
  );
}